import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppRoutes } from '../../constants/app-routes';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, ButtonModule, RouterModule],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  public readonly AppRoutes = AppRoutes;
  today = new Date();
}
